import IMask from 'imask/dist/imask.min'

const moduleName = 'mask';

export function mask() {
    const phoneInputs = document.querySelectorAll('.js-phone');
    if (phoneInputs) {
        Array.from(phoneInputs).forEach((self) => {
            const mask = IMask(self, {
                mask: '+7 (000) 000 00 00',
                lazy: false
            });
        });
    }


    // const smsInputs = document.querySelectorAll('.js-sms-input');
    // if (smsInputs) {
    //     Array.from(smsInputs).forEach((self) => {
    //         const mask = IMask(self, {
    //             mask: '**-**-**',
    //             lazy: false
    //         });
    //     });
    // }

    const smsInputs = document.querySelectorAll('.js-time-input');
    if (smsInputs) {
        Array.from(smsInputs).forEach((self) => {
            const mask = IMask(self, {
                mask: '** : **',
                lazy: false
            });
        });
    }
}
